
import React, { Component } from 'react'; 
import _ from 'lodash';
import { connect } from 'react-redux';
import {InventoryUserMappedAction, TokenValidation} from '../Dashboard/UserActions';
import {SubmitCSATForm, SearchInformation, ScoreCalculation, SearchTepmlateInformation, closeModalPopUp, resetTemplate, ResetUserData, CSATSearchCompleted} from './CSATaction';
import ShowModalPopUp from '../ShowModalPopUp';
import Csatform from './csatform';
import {InventoryMaster} from '../Inventory/InventoryAction';
import SearchCSATRecord from './SearchCSATRecord';
import {Tabs, Tab} from 'react-bootstrap';

class Surveyindex extends Component {
  constructor(props){
		super(props)
		this.state={
      
		}
	}
  componentDidMount(){     
    this.props.actioninventoryUserMapped() 
    this.props.InventoryMaster()
  } 
  loadTabContent = (prop) => {
    this.setState({key:prop})
	}
	ScreensComp = () =>{        
    const{csatuserData, csattemplate, inventoryMapped, ScoreCalculation, loginAction, searchData, masterinventory} = this.props;  
    const{key} = this.state
    if(!_.isEmpty(loginAction)){
    let moduleAccess = _.find(loginAction.modulescreens, {"moduleUId": "CSAT"})
    let returnObj =[]
    _.map(moduleAccess.screens, (obj) =>{ 
        if(obj.screenUId === "HOME_CSAT"){ 
          returnObj.push(<Tab eventKey="HOME_CSAT" title="AUDIT" key={1}>	
        <Csatform function={this.props}
          loginUserName={loginAction.userName} inventoryCsat={masterinventory}
             inventory={inventoryMapped} csattemplate={csattemplate} csatuserData={csatuserData} />
				</Tab>)}
        if(obj.screenUId === "SEARCH_CSAT"){ 
          returnObj.push(<Tab eventKey="SEARCH_CSAT" title="SEARCH" key={2}>	
				<SearchCSATRecord action={this.props} searchData={searchData} loginUserName={loginAction.userName} inventoryCsat={masterinventory}
						ScoreCalculation={ScoreCalculation} inventory={inventoryMapped} 
					/>
        </Tab>)}
    })  
    returnObj =	_.sortBy(returnObj, ['key'])  
   return (<Tabs defaultActiveKey={moduleAccess.screens[0].screenUId} transition={false} 
   activeKey={key ? key : moduleAccess.screens[0].screenUId} unmountOnExit={true}
   id="noanim-tab-example" onSelect={(eventKey)=>this.loadTabContent(eventKey)}>
   {returnObj}</Tabs>)
  }     
  }
  render(){
    let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
		}
		
		return(
			<div  className={(style) ? 'user' : "userSmall"}>
				{(this.props.showerror === true) ?
        <ShowModalPopUp message={this.props.errmessage} 
				falseShowModalPopUp={this.props.closeModalPopUp}/> : null}
				{this.ScreensComp()}	
			</div>)
	}
}    
function mapStateToProps(state){
  return{
   inventoryMapped: state.UserReducer.inventoryMapped,
   csatuserData: state.CSATReducer.csatuserData,
   csattemplate: state.CSATReducer.csattemplate,
   searchData: state.CSATReducer.searchData,
   size: state.UserReducer.large,
   showerror:  state.CSATReducer.showerror, 
   errmessage:  state.CSATReducer.errmessage,    
   loginAction: state.LoginReducer.loginAction,
   showModalLogin: state.UserReducer.showModalLogin,
   masterinventory: state.InventoryReducer.master,
   ScoreCalculation: state.CSATReducer.ScoreCalculation
  }  
}

const mapDispatchToProps = (dispatch) => ({
  actioninventoryUserMapped:  () =>dispatch(InventoryUserMappedAction()),
  actionSubmit:  (a) =>dispatch(SubmitCSATForm(a)),
  actionSearch:  (a) =>dispatch(SearchInformation(a)),
  actionSearchCompleted:  (a) =>dispatch(CSATSearchCompleted(a)),
  actionSearchTemplate:  (a) =>dispatch(SearchTepmlateInformation(a)),  
  closeModalPopUp:  () =>dispatch(closeModalPopUp()), 
  TokenValidation : (a) => dispatch(TokenValidation(a)) ,
  resetTemplate: (a) => dispatch(resetTemplate()),
  InventoryMaster: () =>  dispatch(InventoryMaster()),
  ResetUserData: () => dispatch(ResetUserData()),
  csatScoreCalculation: (a) => dispatch(ScoreCalculation(a)),
})


export default connect(mapStateToProps, mapDispatchToProps)(Surveyindex);


